module.exports = __webpack_public_path__ + "_assets/img/Frame1201.7b367aed.svg";